import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous, object = logged in

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.twofa_required) return data; // non autentica: serve il codice OTP
    setUser(data);
    return data;
  };

  const verifyOtp = async (challenge, code) => {
    const { data } = await api.post("/auth/verify-otp", { challenge, code });
    setUser(data);
    return data;
  };

  const resendOtp = async (challenge) => {
    const { data } = await api.post("/auth/resend-otp", { challenge });
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, verifyOtp, resendOtp }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
